import { Ref, forwardRef, useEffect, useState } from 'react';
import clsx from 'clsx';
import css from './ImageTextLink.module.css';
import { Image } from '../../../images';
import { Link, LinkPropsExt } from '../../components/link';
import { LinkText } from '../../components';
import { ImageAlignment } from '../../../../models';
import { CenterContent } from '../../../containers';

export interface ImageTextLinkProps extends LinkPropsExt {
  className?: string;
  captionClassName?: string;
  imageSource: string;
  caption: string;
  imageAlignment?: ImageAlignment;
}

const linkImageSize = 19;

const ImageTextLinkComponent: React.ForwardRefRenderFunction<
  HTMLAnchorElement,
  ImageTextLinkProps
> = (props: ImageTextLinkProps, ref: Ref<HTMLAnchorElement>) => {
  const [tooltip, setTooltip] = useState<string>('');
  useEffect(() => {
    const newTooltip =
      props.tooltip && props.tooltip.length > 0 ? props.tooltip : props.caption;
    setTooltip(newTooltip);
  }, [props.caption, props.tooltip]);

  return (
    <Link
      ref={ref}
      className={clsx(props.className)}
      tooltip={tooltip}
      disabled={props.disabled}
      onClick={props.onClick}
      allowWrap={props.allowWrap}
    >
      <CenterContent horizontally={false} vertically={true}>
        {props.imageAlignment === ImageAlignment.Left ? (
          <Image
            source={props.imageSource}
            alternateText={props.tooltip ?? ''}
            height={linkImageSize}
            width={linkImageSize}
          />
        ) : null}
        <LinkText
          className={clsx(
            props.captionClassName,
            props.imageAlignment === ImageAlignment.Left
              ? css.captionLeft
              : css.captionRight
          )}
          caption={props.caption}
        />
        {props.imageAlignment === undefined ||
        props.imageAlignment === ImageAlignment.Right ? (
          <Image
            source={props.imageSource}
            alternateText={props.tooltip ?? ''}
            height={linkImageSize}
            width={linkImageSize}
          />
        ) : null}
      </CenterContent>
    </Link>
  );
};

const ImageTextLink = forwardRef(ImageTextLinkComponent);

export default ImageTextLink;
